import React from "react";
import "../Style/Ourproducts.css";

import lookit from "../assets/lookit.png";
import makkal from "../assets/makkal.png";
import hr from "../assets/hrms.png";
import lokal from "../assets/lokall.jpg";
import webtool from "../assets/digitalkit.png";
import arrowIcon from "../assets/blue-arrow.png";

// 🔽 Lookit App — 3 images shown in its stage
import lookitImg1 from "../assets/lookit  (3).jpeg";
import lookitImg2 from "../assets/lookit  (2).jpeg";
import lookitImg3 from "../assets/lookit  (1).jpeg";

// 🔽 Makkal Nalkatti — 3 images shown in its stage
import makkalImg1 from "../assets/mk1 (1).jpeg";
import makkalImg2 from "../assets/mk1 (2).jpeg";
import makkalImg3 from "../assets/mk1 (3).jpeg";

// 🔽 HR Management — 3 images shown in its stage
import hrImg1 from "../assets/hrms (3).jpeg";
import hrImg2 from "../assets/hrms (2).jpeg";
import hrImg3 from "../assets/hrms (1).jpeg";

// 🔽 Lokal — 3 images shown in its stage
import lokalImg1 from "../assets/lokal (1).jpeg";
import lokalImg2 from "../assets/lokal (2).jpeg";
import lokalImg3 from "../assets/lokal (3).jpeg";

// 🔽 WebTool — 3 images shown in its stage
import webtoolImg1 from "../assets/digitalkit (1).jpeg";
import webtoolImg2 from "../assets/digitalkit (2).jpeg";
import webtoolImg3 from "../assets/digitalkit (3).jpeg";

const cards = [
  {
    id: 1,
    title: "Lookit App",
    year: "2025-26",
    users: "5K+",
    icon: lookit,
    images: [lookitImg1, lookitImg2, lookitImg3],
    infoTitle: "Lookit App",
    description:
      "A smart digital platform designed to connect users with content, updates, and insights in a simple and engaging way.",
    link: "https://lookit.mpeoplesnet.com/",
  },
  {
    id: 2,
    title: "Makkal Nalkatti",
    year: "2025-26",
    users: "5K+",
    icon: makkal,
    images: [makkalImg1, makkalImg2, makkalImg3],
    infoTitle: "Makkal Nalkatti",
    description:
      "A local news and information platform that delivers trusted updates, community stories, and regional insights in one place.",
    link: "https://play.google.com/store/apps/details?id=com.makkal.calendar",
  },
  {
    id: 3,
    title: "HR Management",
    year: "2025-26",
    users: "5K+",
    icon: hr,
    images: [hrImg1, hrImg2, hrImg3],
    infoTitle: "HR Management Software",
    description:
      "An all-in-one HR solution to manage employees, attendance, leave, payroll, and performance with ease.",
    link: "https://mpeoples-admin.mpeoplesnet.com/",
  },
  {
    id: 4,
    title: "Lokal",
    year: "2026",
    users: "5K+",
    icon: lokal,
    images: [lokalImg1, lokalImg2, lokalImg3],
    infoTitle: "Lokal",
    description:
      "A service booking platform connecting customers with trusted providers for easy appointments and service management.",
    link: "https://lokal-userpanel.mpeoplesnet.com/",
  },
  {
    id: 5,
    title: "Digital Business Kit",
    year: "2026",
    users: "5K+",
    icon: webtool,
    images: [webtoolImg1, webtoolImg2, webtoolImg3],
    infoTitle: "Digital Kit",
    description:
      "A digital business platform designed to help businesses showcase their products, connect with customers, and build their online presence.",
    link: "https://digitalkit.mpeoplesnet.com/",
  },
];

// Each product's screenshots cycle automatically — timing driven purely by
// CSS keyframes (see --cycle / animation-delay in the stylesheet), no JS timers.
const CYCLE_SECONDS = 3; // seconds each image stays on screen

const ProductCards = () => {
  return (
    <section className="products-section" id="our-products">
      <div className="products-header">
        <span className="products-eyebrow">What We've Built</span>
        <h2 className="products-title">Our Products</h2>
        <p className="products-subtitle">
          Live products we've designed, built, and continue to ship.
        </p>
      </div>

      <div className="cards-grid">
        {cards.map((card) => (
          <article className="product-card" key={card.id}>

            {/* Auto-cycling image stage */}
            <div
              className="product-stage"
              style={{
                "--slide-count": card.images.length,
                "--cycle": `${CYCLE_SECONDS}s`,
              }}
            >
              {card.images.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`${card.title} screenshot ${i + 1}`}
                  className="product-slide"
                  style={{
                    animationDelay: `${i * CYCLE_SECONDS}s`,
                  }}
                />
              ))}

              <div className="product-stage-scrim" />

              <div className="product-icon-badge">
                <img src={card.icon} alt="" />
              </div>

              <div className="product-dots">
                {card.images.map((_, i) => (
                  <span
                    key={i}
                    className="product-dot"
                    style={{
                      animationDelay: `${i * CYCLE_SECONDS}s`,
                    }}
                  />
                ))}
              </div>
            </div>

            {/* Content */}
            <div className="product-body">
              <div className="product-meta">
                <span className="product-meta-pill">
                  {card.year}
                </span>

                <span className="product-meta-pill product-meta-pill--accent">
                  {card.users} Users
                </span>
              </div>

              <h3 className="product-name">
                {card.infoTitle}
              </h3>

              <p className="product-desc">
                {card.description}
              </p>

              {/* FIXED: missing opening <a> tag */}
              <a
                className="product-link"
                href={card.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more

                <span className="product-link-arrow">
                  <img src={arrowIcon} alt="" />
                </span>
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ProductCards;